module.exports = __webpack_public_path__ + "img/gonzhonghao.e82e11e6.png";